import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["onClick"]

import {computed, ref} from 'vue';
import {
    CHAT_SEND_MESSAGE_SHORTCUT_CTRL_ENTER,
    CHAT_SEND_MESSAGE_SHORTCUT_ENTER, CHAT_SEND_MESSAGE_SHORTCUT_META_ENTER,
    OperatorApplicationConfigInstance
} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import InlineSelect from "~/core-ui/vue/ui/InlineSelect.vue";
import OperatorApplicationPlatform from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import StringHelper from "~/ts/library/StringHelper";
import OperatorApplicationPlatformFactory from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import {SpellcheckLanguageInterface} from "~/operatorApplication/ts/platform/AbstractOperatorApplicationPlatform";
import {__} from "~/ts/library/Translate";
import OperatorApplicationConfigChatForServerSide
    from "~/operatorApplication/vue/config/OperatorApplicationConfigChatForServerSide.vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {getPathByFile} from "~/operatorApplication/ts/service/getPathByFile";



const __default__ = {
    name: "OperatorApplicationConfigChat"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let file = ref<HTMLInputElement>(null);
let configuration = computed(() => {
    return OperatorApplicationConfigInstance;
});

let colors = computed(() => {
    return [
        "silver", "blue", "green", "yellow", "purple", "sea", "pink", "asphalt"
    ];
});

let spellcheckLanguages = ref<SpellcheckLanguageInterface[]>([]);
(async () => {
    spellcheckLanguages.value = await OperatorApplicationPlatformFactory.getSpellcheckAvailableLanguages();
})();

let sendShortcuts = computed(() => {
    return [
        {
            value: CHAT_SEND_MESSAGE_SHORTCUT_ENTER, descr: "Enter"
        },
        {
            value: CHAT_SEND_MESSAGE_SHORTCUT_CTRL_ENTER, descr: "Ctrl+Enter"
        },
        {
            value: CHAT_SEND_MESSAGE_SHORTCUT_META_ENTER, descr: "Meta+Enter"
        }
    ]
});

let backgrounds = computed(() => {
    let result = [null, ...configuration.value.standartBackgrounds];
    let background = configuration.value.historyBackground;
    if (background && result.indexOf(background) == -1) {
        result.push(background);
    }
    return result;
});

function addSlashes(bg: string) {
    return StringHelper.addSlashes(bg);
}

let isNative = computed(() => {
    return OperatorApplicationPlatform.isNative;
});

function onFileSelect() {
    let fileItem: any = file.value.files.item(0);
    if (file) {
        configuration.value.historyBackground = getPathByFile(fileItem);
        file.value.value = "";
    }
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_slider = _resolveComponent("el-slider")!
  const _component_el_switch = _resolveComponent("el-switch")!

  return (_openBlock(), _createBlock(OperatorApplicationConfigChatForServerSide, {
    configuration: _unref(OperatorApplicationConfigInstance),
    "is-server-side": _unref(OperatorAccountStore).isServerSideSettings
  }, {
    "after-sticky-dialog-info": _withCtx(() => [
      (_unref(spellcheckLanguages) && _unref(spellcheckLanguages).length)
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: _unref(__)('Языки для проверки правописания')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _unref(configuration).spellcheckLanguages,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(configuration).spellcheckLanguages) = $event)),
                class: "w-100",
                multiple: "",
                placeholder: _unref(__)('Не указаны, должно определяться системой'),
                filterable: "",
                "default-first-option": ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(spellcheckLanguages), (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      value: item.id,
                      label: item.descr
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    "after-ip-info-url": _withCtx(() => [
      _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(__)('Отправлять сообщения по нажатию')) + " ", 1),
          _createVNode(InlineSelect, {
            modelValue: _unref(configuration).chatSendMessageShortcut,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(configuration).chatSendMessageShortcut) = $event)),
            options: _unref(sendShortcuts).map(item => ({ value: item.value, label: item.descr }))
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }),
      (_unref(OperatorApplicationPlatformFactory).isNative)
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: _unref(__)('Размер шрифта в чате')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_slider, {
                modelValue: _unref(configuration).chatHistoryScale,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(configuration).chatHistoryScale) = $event)),
                step: 0.05,
                min: 0.8,
                max: 2,
                style: {"max-width":"550px"},
                "format-tooltip": (value) => `${Math.ceil(value * 100)}%`
              }, null, 8, ["modelValue", "format-tooltip"])
            ]),
            _: 1
          }, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    "after-reply-lines": _withCtx(() => [
      (!_unref(configuration).darkThemeEnabled)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_el_form_item, {
              label: _unref(__)('Цвет сообщения оператора:')
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(colors), (color) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: color,
                    onClick: ($event: any) => (_unref(configuration).operatorMessageBackground = color),
                    class: _normalizeClass({
                        color: true,
                        [color]: true,
                        selected: color === _unref(configuration).operatorMessageBackground
                    })
                  }, null, 10, _hoisted_1))
                }), 128))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(__)('Фон')
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(backgrounds), (bg) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: bg,
                    style: _normalizeStyle({backgroundImage: bg ? `url('${addSlashes(bg)}')` : 'none'}),
                    class: _normalizeClass({
                            'background-selector': true,
                            empty: !bg
                        }),
                    onClick: ($event: any) => (_unref(configuration).historyBackground = bg)
                  }, [
                    (bg === _unref(configuration).historyBackground)
                      ? (_openBlock(), _createBlock(FontAwesomeIcon, {
                          key: 0,
                          class: "selected",
                          icon: "check"
                        }))
                      : _createCommentVNode("", true)
                  ], 14, _hoisted_2))
                }), 128)),
                (_unref(isNative))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "background-selector new",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(file).click()))
                    }, [
                      _createElementVNode("div", null, [
                        _createVNode(FontAwesomeIcon, {
                          icon: "plus",
                          light: ""
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("input", {
                  type: "file",
                  ref_key: "file",
                  ref: file,
                  class: "d-none",
                  onChange: onFileSelect,
                  accept: ".jpg,.jpeg,.png,.gif"
                }, null, 544),
                _createElementVNode("div", null, [
                  _createVNode(_component_el_switch, {
                    modelValue: _unref(configuration).historyBackgroundRepeat,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(configuration).historyBackgroundRepeat) = $event))
                  }, null, 8, ["modelValue"]),
                  _createTextVNode(" " + _toDisplayString(_unref(__)('Замостить фон')), 1)
                ])
              ]),
              _: 1
            }, 8, ["label"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["configuration", "is-server-side"]))
}
}

})